import request from "@/utils/request";

// 首页资讯和动态列表接口
export const getHomeInformationList = (data) =>
  request({
    url: "/basic-common/information/list",
    method: "post",
    data,
  });

//获取引用商店类型
export function appClassifyList() {
  return request({
    url: `/eco-external/boss/cloud/appClassifyList`,
    method: "GET",
  });
}

// 多条件查询应用商店APP列表（首页）
export function getAppHomePageList(params) {
  return request({
    url: `/eco-external/boss/cloud/getAppHomePageList`,
    method: "GET",
    params,
  });
}

// 获取置顶数据
export const getTopList = (params) =>
  request({
    url: "/basic-common/information/topList",
    method: "get",
    params,
  });

// 获取字典
export const getDictsByDictCategoryCodeList = (params) =>
  request({
    url: "/basic-common/basic/notAuth/dict/getDictsByDictCategoryCodeList",
    method: "GET",
    params,
  });

// 获取资讯详情
export const getInformationDetail = (data) =>
  request({
    url: `/basic-common/information/getInformation/${data.id}`,
    method: "GET",
    data,
  });

// 更新资讯浏览量
export const updateViewCount = (data) =>
  request({
    url: `/basic-common/information/updateViewCount/${data.id}`,
    method: "PUT",
    data,
  });
